import React from 'react'

const SEAM_OUTLINE = 'rgba(54,66,78,.16)'
const SEAM_HIGHLIGHT = 'rgba(255,255,255,.9)'

const Envelope = () => (
  <>
    <div className="hero-envelope__slide hero-envelope__back-layer">
      <div className="hero-envelope__back" />
    </div>

    <div className="hero-envelope__slide hero-envelope__front-layer">
      <div className="hero-envelope__pocket">
        <div className="hero-envelope__pocket-left" />
        <div className="hero-envelope__pocket-right" />
        <div className="hero-envelope__pocket-bottom" />
        <svg
          className="hero-envelope__seams"
          viewBox="0 0 300 196"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d="M0 0 L150 98 M300 0 L150 98 M0 196 L150 98 M300 196 L150 98"
            fill="none"
            stroke={SEAM_OUTLINE}
            strokeWidth="1"
          />
          <path
            d="M2 2 L150 98 M298 2 L150 98"
            fill="none"
            stroke={SEAM_HIGHLIGHT}
            strokeWidth="1"
          />
        </svg>
      </div>
    </div>

    <div className="hero-envelope__slide hero-envelope__flap-layer">
      <div className="hero-envelope__flap" />
    </div>
  </>
)

export default Envelope
